import { EmptyObject } from './../../types/handlers';
import { RouteFeature } from './../mapping/drawing/RouteFeature';
import { ObjID } from 'app/model/id-manager';
import { IDRegistry } from './../id-registry';
import { IDManager } from './../id-manager';
import { RoutesContext, RouteID } from './routes.service';
import { EventEmitter, Injectable } from '@angular/core';
import { Destructable } from 'app/types/destructable';

export type RouteData = {
  vertices: Array<any>,
  segments: Array<any>
}

export type RouteContext = Destructable & {
  idManager: IDManager;
  idRegistry: IDRegistry;
}
export type RouteInfo = {
  id?: RouteID;
  index?: number;
  name: string;
  hasChildren?: boolean;
  children?: Array<RouteID>;
  data?: RouteData | EmptyObject;
  parent?: RouteID;
  costs?: any;
  feature?: RouteFeature;
  expanded?:boolean;
}

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  public static instance:RouteService;
  public context?: RouteContext;
  constructor() {
    RouteService.instance = this;
  }
  GetRoute(id: RouteID): RouteInfo {
    if (!this.context) throw new Error('context not set');
    return this.context.idRegistry.Get(id);
  }
  HasSubRoutes(routeId: RouteID): boolean {
    const route = this.GetRoute(routeId);
    if (!route) return false;
    return route.hasChildren === true;
  }
  GetSubRoutes(routeId: RouteID) {
    const route = this.GetRoute(routeId);
    if (route.hasChildren === false) return [];
    return route.children;
  }
  GetTopRoute(routeId:RouteID):RouteInfo {
    let route = this.GetRoute(routeId);
    let hasParent = !!route.parent;
    while(hasParent === true) {
      if(!route.parent) {
        hasParent = true;
        break;
      }
      route = this.GetRoute(route.parent);
      hasParent = !!route.parent;
    }
    return route;
  }
  AddSubRoute(addToId: RouteID, newRouteId: RouteID) {
    const route = this.GetRoute(addToId);
    if (!route) throw new Error('trying to add subroute to a route that does not exist');
    if (!route.children) {
      route.children = [];
      route.hasChildren = true;
    }
    route.children.push(newRouteId);
    try {
      const child = this.GetRoute(newRouteId) as RouteInfo;
      child.parent = addToId;
    } catch (err) { }
  }

  SetContext(context: RouteContext) {
    this.context = context;
    this.context.onDestroy.subscribe(() => {
      this.context = undefined;
    });
  }
  GetFullName(id: RouteID, name: string = '', separator = '.') {
    if (!name) name = '';
    const route: RouteInfo = this.context?.idRegistry.Get(id);
    name = (name === '') ? route.name : route.name + separator + name;
    if (route && route.parent) {
      name = this.GetFullName(route.parent, name, separator);
    }
    return name;
  }
  GetIDPath(id: RouteID, path?: Array<RouteID>): Array<RouteID> {
    if (!path) path = [];
    const route: RouteInfo = this.GetRoute(id);
    if (route && route.parent) {
      path.unshift(route.parent);
      this.GetIDPath(route.parent, path);
    }
    return path;
  }
  GetIndexPath(id: RouteID, path?: Array<number>): Array<number> {
    const isStart = !path;
    if (!path) path = [];
    const route: RouteInfo = this.GetRoute(id);
    if (route) {
      path.unshift(route.index!);
      if (route.parent !== undefined) {
        this.GetIndexPath(route.parent, path);
      }
    }
    if (isStart) path.pop();
    return path;
  }

}
